<template>
<form v-if="!is_success" class="w-100" @submit.prevent="sendFormData">
    <div class="row w-100 g-3 mt-md-0">
        <div :class="{'bad-field':hasBadField('name')}" class="col-md-6 col-lg-6 mt-4 mt-md-0">
            <input v-model="form.name" aria-label="Имя" class="form-control w-100" placeholder="Имя*" type="text">
        </div>
        <div :class="{'bad-field':hasBadField('surname')}" class="col-md-6 col-lg-6 mt-4 mt-md-0">
            <input v-model="form.surname" aria-label="Фамилия" class="form-control w-100" placeholder="Фамилия"
                   type="text">
        </div>
        <div :class="{'bad-field':hasBadField('city')}" class="col-md-12 mt-4">
            <input v-model="form.city" aria-label="Город" class="form-control w-100" placeholder="Город*" type="text">
        </div>
        <div :class="{'bad-field':hasBadField('phone')}" class="col-md-12 mt-4">
            <input
                v-model="form.phone"
                v-phone
                aria-label="+7 (900) 000-0000"
                autocomplete="tel"
                class="form-control w-100"
                max-length="14"
                placeholder="+7 (900) 000-0000*">
        </div>
        <div :class="{'bad-field':hasBadField('text')}" class="col-md-12 mt-4">
                            <textarea v-model="form.text" class="form-control w-100" placeholder="Ваш отзыв" rows="5"
                                      type="text"></textarea>
        </div>
        <div :class="{'bad-field':hasBadField('agreement_policy')}" class="col-md-12 mt-4 d-flex gap-3">
            <input id="privacy-policy" v-model="agreement_policy" class="form-check-input" type="checkbox">
            <label class="form-check-label fw-light" for="privacy-policy">Вы даёте согласие на обработку персональных
                данных. С Политикой обработки персональных данных Вы можете ознакомиться <a :href="policy_private_url" class="text-reset">здесь</a></label>
        </div>

        <!--        <div :class="{'bad-field':hasBadField('agreement_company')}" class="col-md-12 mt-4 d-flex gap-3">-->
        <!--            <input id="company-policy" v-model="agreement_company" class="form-check-input" type="checkbox">-->
        <!--            <label class="form-check-label fw-light" for="company-policy">Вы принимаете правила <a :href="policy_url">политики-->
        <!--                компании.</a></label>-->
        <!--        </div>-->

        <div class="col-md-12 col-lg-12">
            <button class="btn bauer-button-small w-100 min-w-100  text-uppercase">Отправить
                отзыв
            </button>
        </div>
    </div>
    <Notifications :notifications="notifications"/>
</form>
<template v-else>
    <h3>Форма отправлена!</h3>
</template>
</template>

<script>
    import fn from "../../../js/fn";
    import Notifications from "../../vue-components/Notifications";
    import PhoneMask from "../../vue-components/directives/PhoneMask";

    export default {
        name: "FormApp",
        components: {Notifications},
        directives: {
            'phone': PhoneMask
        },
        props: {
            policy_url: {
                type: String,
                required: true
            },
            policy_private_url: {
                type: String,
                required: true
            },
        },
        // mounted() {
        //     this.$el.outerHTML = this.$el.innerHTML;
        // },
        data() {
            return {
                process: false,
                form: {
                    name: null,
                    phone: null,
                    surname: null,
                    city: null,
                    text: null,
                },
                notifications: [],
                agreement_company: false,
                agreement_policy: false,
                is_success: false
            }
        },
        computed: {
            formTitle() {
                return this.is_success ? 'Спасибо, за доверие!' : this.title;
            }
        },
        methods: {
            resetForm() {
                this.form = {
                    name: null,
                    phone: null,
                    surname: null,
                    city: null,
                    text: null
                }
                // this.agreement_company = false
                this.agreement_policy = false
                this.notifications = []
                this.is_success = false
            },
            sendFormData() {
                if (this.process) {
                    return
                }
                this.notifications = []

                this.checkField();

                if (this.notifications.length > 0) {
                    this.process = false;
                    return;
                }

                this.process = true

                fn.sync({
                    url: '/zen/project/api/feedback:send',
                    data: {form: this.form},
                    then: response => {
                        this.process = false
                        this.notifications = response.notifications
                        if (response.success) {
                            this.is_success = true
                            setTimeout(() => {
                                this.resetForm();
                            }, 8000);
                        }
                    },
                    error: error => {
                        this.process = false
                    }
                })
            },
            checkField() {
                if (!this.agreement_policy) {
                    this.notifications.push({
                        text: 'Не подтверждено согласие на обработку персональных данных',
                        type: 'danger',
                        field: 'agreement_policy'
                    })
                }
                // if (!this.agreement_company) {
                //     this.notifications.push({
                //         text: 'Вы не приняли правила политики компании',
                //         type: 'danger',
                //         field: 'agreement_company'
                //     })
                // }
                if (!this.form.name || this.form.name.length < 3) {
                    this.notifications.push({
                        text: 'Поле Имя, обязательно для заполнения!',
                        type: 'danger',
                        field: 'name'
                    })
                }
                if (!this.form.phone || this.form.phone.length !== 18) {
                    this.notifications.push({
                        text: 'Поле Телефон, обязательно для заполнения!',
                        type: 'danger',
                        field: 'phone'
                    })
                }
                if (!this.form.city || this.form.city.length < 3) {
                    this.notifications.push({
                        text: 'Поле Город, обязательно для заполнения!',
                        type: 'danger',
                        field: 'city'
                    })
                }
                if (!this.form.text || this.form.text.length < 15) {
                    this.notifications.push({
                        text: 'Поле Отзыв, обязательно для заполнения!',
                        type: 'danger',
                        field: 'text'
                    })
                }
            },
            hasBadField(field) {
                return !!this.notifications.find(notification => {
                    return notification.field === field
                })
            }
        }
    }
</script>

